import { createValidationSchema, validate } from "@";

// Define validation schema for Our Partners form
export const schema = createValidationSchema({
  Title: validate("req", "Title"),
  Link: validate("url", "Link"),
});

// Define initial values for Our Partners form
export const defaultValues = {
  id: null,
  Image: "",
  Title: "",
  Link: "",
};
